'use client';

import {
  ClientContext,
  type ClientContextValue,
  type ClientType,
} from '@unifyapps/carbon/context/client';
import { ClientContextSearchParams } from '@unifyapps/carbon/context/client/const';
import { useSearchParams } from '@unifyapps/carbon/navigation';
import type { ExtensionApp } from '@unifyapps/defs/types/extensionApp';
import { type PropsWithChildren, useMemo } from 'react';

export function MatrixClientContextProvider(props: PropsWithChildren<ClientContextValue>) {
  const { children, app: baseApp, client: baseClient, renderInShadowDom, value: baseValue } = props;

  const searchParams = useSearchParams();
  const app = searchParams.get(ClientContextSearchParams.APP) as ExtensionApp | undefined;
  const client = searchParams.get(ClientContextSearchParams.CLIENT) as
    | ClientType.MatrixExtension
    | undefined;

  const value = useMemo(
    () => ({
      app: app || baseApp,
      client: client || baseClient,
      renderInShadowDom,
      value: baseValue,
    }),
    [baseApp, baseClient, baseValue, app, client, renderInShadowDom],
  );

  return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
}
